import React, { Component } from 'react';
import classnames from 'classnames';

type WorkAbstractLiteProps = React.PropsWithChildren<{
  expanded?: boolean;
  handleExpand?: () => void;
  lessButton?: boolean;
  freebieMention?: boolean;
}>;

// stateless version
export const WorkAbstractLite: React.FC<WorkAbstractLiteProps> = ({
  expanded,
  children,
  handleExpand,
  lessButton,
  freebieMention,
}) => (
  <div
    className={classnames('wp-workCard--abstract wp-workCard_item', {
      expanded,
    })}
    style={freebieMention ? { marginBottom: '0.5em' } : undefined}
  >
    <div
      className={classnames('wp-workCard--abstract_content', {
        truncate: freebieMention || !expanded,
      })}
    >
      <span>{children}</span>
      {!freebieMention && expanded && lessButton && (
        <span className="wp-workCard--abstract_less_button">
          <a href="javascript:void(0);" onClick={handleExpand}>
            less ▴
          </a>
        </span>
      )}
    </div>
    {!freebieMention && (
      <div className="wp-workCard--abstract_more_button">
        <a href="javascript:void(0);" onClick={handleExpand}>
          more ▾
        </a>
      </div>
    )}
  </div>
);

type WorkAbstractProps = React.PropsWithChildren<{
  initialExpanded?: boolean;
  lessButton?: boolean;
  freebieMention?: boolean;
}>;

interface WorkAbstractState {
  expanded: boolean;
}

export class WorkAbstract extends Component<
  WorkAbstractProps,
  WorkAbstractState
> {
  constructor(props: WorkAbstractProps) {
    super(props);
    this.state = {
      expanded: props.initialExpanded ? true : false,
    };
  }

  handleExpandToggle = () => {
    this.setState((state) => ({ expanded: !state.expanded }));
  };

  render() {
    return (
      <WorkAbstractLite
        handleExpand={this.handleExpandToggle}
        expanded={this.state.expanded}
        lessButton={this.props.lessButton}
        freebieMention={this.props.freebieMention}
      >
        {this.props.children}
      </WorkAbstractLite>
    );
  }
}
